/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterH = createReactComponent("letter-h", "IconLetterH", [
  ["path", { d: "M17 4l0 16", key: "svg-0" }],
  ["path", { d: "M7 12l10 0", key: "svg-1" }],
  ["path", { d: "M7 4l0 16", key: "svg-2" }]
]);

export { IconLetterH as default };
//# sourceMappingURL=IconLetterH.js.map
